import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Container, Wrapper, ButtonWrapper } from "./AdminAddPharmacyPageStyle";
import useApiService from "../../utilities/useApiService";
import { useQuery } from "react-query";
import { CallToActionButton } from "../../atoms/callToActionButton/CallToActionButton";
import { largeButton } from "../../utilities/style";
import { useHistory } from "react-router-dom";
import FormMolecule from "../../molecules/Form/FormMolecule";
import { createSelectUserForm } from "./FormData";
import { useAuthState } from "../../context/AuthContext";
import { UserRole } from "../../utilities/Enums";
import { isRoleIncluded } from "../../utilities/checkUserRole";
import { toastFail } from "../../utilities/toast";

export interface AdminAddPharmacyPageProps { }

const AdminAddPharmacyPage: React.FC<AdminAddPharmacyPageProps> = (props) => {
  const { control, handleSubmit } = useForm();
  const { getMethod } = useApiService();
  let history = useHistory();
  const { user } = useAuthState();
  const isAllowed = isRoleIncluded([UserRole.Admin], user?.role);
  useEffect(() => {
    if (!isAllowed) {
      toastFail("You are not allowed to enter here !");
      history.push("/");
    }
  }, [isAllowed, history]);
  const fetchUsers = async () => {
    const response = await getMethod('/admin/users');
    return response.data;
  }
  const { data: users } = useQuery('users', fetchUsers, { enabled: isAllowed });

  const mapUsersToOptions = () => {
    const filteredUsers = users
      ?.filter((user: any) => user.role === "USER")
      ?.sort(
        (a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );

    return (
      filteredUsers?.map((user: any) => ({
        label: user.username,
        value: user.id,
      })) || []
    );
  };

  const handleClick = handleSubmit((data) => {
    history.push(`/admin/users/${data.user}/pharmacy/add`)
  })
  

  return (
    <Container>
      <Wrapper>
        <FormMolecule
          control={control}
          list={createSelectUserForm(mapUsersToOptions())}
        />
        <ButtonWrapper>
          <CallToActionButton
            height={"80px"}
            text="Add Pharmacy"
            width={largeButton.width}
            onClick={handleClick}
          />
        </ButtonWrapper>
      </Wrapper>
    </Container>
  );
};
export default AdminAddPharmacyPage;
